import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class BrandService extends BaseService {

 
    static apis = {
        specBrands: function(){
            return 'spec-brands'
        },
        getLogos:function(){
            return "brands-logos"
        }
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("brands");
    }

    getSpecBrands(){
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ 
                url: BrandService.apis.specBrands(),
                method: "GET",
                showLoader: true,
                authorization: true,
             })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getLogos() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: BrandService.apis.getLogos(), method: "GET", authorization: false, showLoader: true })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }


}

export default BrandService;